module.exports = __webpack_public_path__ + "static/fox_example-944f741d967c5a16acc49eca06b25400.png";